exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".numeric-summary[data-v-683a6480]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.numeric-summary .label[data-v-683a6480]{text-align:right}.numeric-summary .value[data-v-683a6480]{text-align:left;padding-left:2rem}.po-title[data-v-683a6480]{font-size:16px;font-weight:700;color:#dd711f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-683a6480","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/InvoicePDF.vue
// module id = 506
// module chunks = 0